import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState('gonglue');

  const filteredArticles = articles.filter((a) => a.category === activeCategory);
  const currentCategory = categories.find((c) => c.id === activeCategory);

  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '征途国际内容分类',
      description: '征途国际游戏攻略、新闻资讯、官方公告、视频专区分类浏览',
      url: 'https://ztroute.github.io/categories',
    },
  ];

  return (
    <>
      <SEOHead
        title="征途国际分类-游戏攻略与资讯 | 征途国际官方下载站"
        description="浏览征途国际游戏攻略、最新新闻资讯、官方公告和视频专区。获取最全面的征途国际游戏信息。"
        keywords="征途国际攻略,征途国际新闻,征途国际公告,征途国际资讯"
        canonicalUrl="https://ztroute.github.io/categories"
        schemaData={schemaData}
      />
      <Navbar />
      <main className="pt-20 pb-14 bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '分类' },
            ]}
          />

          <header className="mb-10">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              内容分类
            </h1>
            <p className="text-foreground-600 text-sm md:text-base">
              浏览征途国际攻略、资讯、公告等内容
            </p>
          </header>

          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap flex items-center gap-2 cursor-pointer ${
                  activeCategory === cat.id
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          {currentCategory && (
            <div className="mb-8">
              <p className="text-sm text-foreground-500">{currentCategory.description}</p>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filteredArticles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-1 rounded-full font-medium">
                      {currentCategory.name}
                    </span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="text-center py-20">
              <div className="w-16 h-16 bg-background-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-inbox-line text-foreground-400 text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无内容</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}